export const ENDPOINT_BASE_URL = import.meta.env.VITE_BASE_URL;

export const ENDPOINT_ROOT = `${ENDPOINT_BASE_URL}`;

export const ENDPOINT_SESSION = '/sessions';
export const ENDPOINT_LOGIN = '/auth/login';

export const ENDPOINT_CURRENT_USER = '/api/users/get_current_user';

export const ENDPOINT_PARTIES = '/api/parties';

export const ENDPOINT_PARTIES_CLOSE_PARTY_SLUG =
  '/api/parties/close_party/{slug}';

export const ENDPOINT_SELECT_PARTIES = '/api/parties/reception-list';

export const ENDPOINT_CROP_TYPES = '/api/crop-types';
export const ENDPOINT_CROP_GENERATIONS = '/api/crop-generations';

export const ENDPOINT_SETTINGS = '/api/user-settings/by-user';
export const ENDPOINT_SCALE_TYPES = '/api/scale-types';
export const ENDPOINT_CAMERA_TYPES = '/api/camera-types';

export const ENDPOINT_FARMER_CONTRACTS = '/api/farmer-contracts/by-farmer-tin';

export const ENDPOINT_FARMER_CONTRACTS_BY_RECEPTION_SLUG =
  '/api/farmer-contracts/by-reception/{slug}';

export const ENDPOINT_RECEPTION = '/api/receptions';
export const ENDPOINT_RECEPTION_COUNT = '/api/receptions/counts';
export const ENDPOINT_RECEPTION_ANALYSIS = '/api/receptions/analysis';
export const ENDPOINT_RECEPTION_BY_PAGE = '/api/receptions/by-page';
export const ENDPOINT_RECEPTION_ANALYSIS_BY_PAGE =
  '/api/receptions/analysis/by-page';

export const ENDPOINT_RECEPTION_CARGO = '/api/receptions/save-cargo-info';

export const ENDPOINT_LAB_ANALYSIS = '/api/receptions/save-analysis-info';
export const ENDPOINT_LAB_ANALYSIS2 = '/api/receptions/save-analysis';

export const ENDPOINT_TRANSPORT_TYPE = '/api/transport-types';

export const ENDPOINT_IMAGE_UPLOAD = '/api/files/upload-jpeg-stream';
export const ENDPOINT_IMAGE_DOWNLOAD = (id: string) =>
  `${ENDPOINT_ROOT}/public/files/download/${id}`;

export const ENDPOINT_RECEPTION_WEIGHINGS = '/api/receptions/weighings';

export const ENDPOINT_RECEPTION_FINISH_WEIGHINGS =
  '/api/receptions/finish-weighings';

export const ENDPOINT_CLUSTERS_BY_ID = '/api/clusters/by-place-id';

export const ENDPOINT_STATISTICS = '/api/statistics';
export const ENDPOINT_STATISTICS_PARTIES = '/api/statistics/by-parties';

export const ENDPOINT_RECEPTIONS_MANAGE_FARMER_CONTRACT =
  '/api/receptions/manage-farmer-contract/{id}';

export const ENDPOINT_RECEPTION_SLUG = '/api/receptions/{slug}';

export const ENDPOINT_STATISTICS_BY_CLUSTER_SLUG =
  '/api/statistics/by-cluster/{slug}';

export const ENDPOINT_GRAIN_PARTIES = '/api/grain-parties';

export const ENDPOINT_GRAIN_RECEPTION_BY_PAGE = '/api/grain-reception/page';

export const ENDPOINT_PLANTS_GRAIN = '/api/plants/grain';

export const ENDPOINT_SET_PLATFORM_TYPE = '/auth/set-platform-type';

export const ENDPOINT_CROP_TYPES_BY_PLANT = '/api/crop-types/by-plant';

export const ENDPOINT_CROP_GENERATIONS_BY_PLANT_ID =
  '/api/crop-generations/by_plant_id/{plant_id}';

export const ENDPOINT_GRAIN_RECEPTION_COUNTS = '/api/grain-reception/counts';

export const ENDPOINT_GRAIN_RECEPTION_DETAIL = '/api/grain-reception/{id}';

export const ENDPOINT_FARMER_CONTRACTS_BY_TIN =
  '/api/farmer-contracts/grain/{tin}';

export const ENDPOINT_GRAIN_RECEPTION = '/api/grain-reception';

export const ENDPOINT_GRAIN_RECEPTION_MANAGE_FARMER_CONTRACT =
  '/api/grain-reception/manage-farmer-contract/{id}';

export const ENDPOINT_GRAIN_PARTIES_SELECT = '/api/grain-parties/select';

export const ENDPOINT_GRAIN_RECEPTION_UPDATE_PARTY =
  '/api/grain-reception/update-party/{id}';

export const ENDPOINT_GRAIN_RECEPTION_BY_FARMER =
  '/api/grain-reception/by-farmer/{tin}';

export const ENDPOINT_GRAIN_RECEPTION_SAVE_ANALYSIS =
  '/api/grain-reception/save-analysis';

export const ENDPOINT_FARMER_CONTRACTS_BY_TIN_ANALYSIS =
  '/api/farmer-contracts/grain-analysis-contracts/{tin}';
